import {useEffect} from "react";
import isEmpty from "is-empty";
import {route} from "ziggy-js";

export default function useDetectLocation() {
    useEffect(() => {
        if (!isEmpty(localStorage.getItem('cityCookieDadataAdd'))) return;

        setTimeout(() => {
            localStorage.setItem('cityCookieDadataAdd', true);
            axios.post(route('location.detection'), {}).then((response) => {
                const {status = false} = response.data;
                if (status) {
                    // router.reload();
                }
            });
        }, 5000)
    });
}
